(() => {
  function initGhoulishCollection(root = document) {
    // Scroll reveal (matches homepage)
    const revealEls = root.querySelectorAll ? root.querySelectorAll('.reveal:not([data-ghoulish-reveal-bound])') : [];
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            e.target.removeAttribute('data-ghoulish-reveal-bound');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1 });

      revealEls.forEach(el => {
        el.setAttribute('data-ghoulish-reveal-bound', 'true');
        io.observe(el);
      });
    } else {
      revealEls.forEach(el => el.classList.add('in'));
    }

    // Original/Shadow edition toggle (Shopify variant-aware)
    root.querySelectorAll('.p-card .p-edition-toggle:not([data-ghoulish-toggle-bound]), .coll-hero-preview .p-edition-toggle:not([data-ghoulish-toggle-bound])').forEach(toggle => {
      toggle.setAttribute('data-ghoulish-toggle-bound', 'true');

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const card = toggle.closest('.p-card, .coll-hero-preview');
        if (!card || card.classList.contains('is-fading')) return;

        const label = card.querySelector('.p-toggle-label');
        const isShadow = !card.classList.contains('is-shadow');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function swap() {
          card.classList.toggle('is-shadow', isShadow);
          card.dataset.edition = isShadow ? 'shadow' : 'original';
          if (label) label.textContent = isShadow ? 'Shadow' : 'Original';
          toggle.setAttribute('aria-checked', isShadow ? 'true' : 'false');

          // Update product links to deep-link to the selected variant
          const variantId = isShadow ? card.dataset.shadowVariantId : card.dataset.originalVariantId;
          const baseUrl = card.dataset.productUrl;
          const newUrl = variantId ? `${baseUrl}?variant=${variantId}` : baseUrl;

          if (baseUrl) {
            card.querySelectorAll('a[href]').forEach(a => {
              const href = a.getAttribute('href');
              if (href && href.includes(baseUrl.split('?')[0])) {
                a.setAttribute('href', newUrl);
              }
            });
          }
        }

        if (reduced) { swap(); return; }

        card.classList.add('is-fading');
        window.setTimeout(() => {
          swap();
          window.setTimeout(() => card.classList.remove('is-fading'), 35);
        }, 240);
      });
    });

    // Whole-card click navigation, while preserving normal link/button behavior
    root.querySelectorAll('.p-card:not([data-ghoulish-card-bound]), .coll-hero-preview:not([data-ghoulish-card-bound])').forEach(card => {
      card.setAttribute('data-ghoulish-card-bound', 'true');

      card.addEventListener('click', (event) => {
        if (event.target.closest('a, button, input, select, textarea')) return;

        const link = card.querySelector('.p-img-link, .coll-hero-preview-link, .p-name a');
        if (link && link.href) window.location.href = link.href;
      });
    });
  }

  function ready() {
    initGhoulishCollection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    initGhoulishCollection(event.target);
  });
})();
